/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout/org_admin_Index'

const orgAdminRouter = {
  name: 'OrgAdmin',
  path: '/org-admin',
  redirect: '/org-admin/index',
  component: Layout,
  meta: { title: '团队后台管理' },
  children: [
    {
      path: 'index',
      name: 'OrgAdminBase',
      meta: { title: 'router.team-set' },
      component: () => import('@/views/org_admin/index.vue')
    },
    {
      path: 'member-department',
      name: 'MemberDepartment',
      meta: { title: 'router.team-member-department' },
      component: () => import('@/views/org_admin/member_department.vue')
    },
    {
      path: 'member-approve',
      name: 'MemberApprove',
      meta: { title: 'router.team-member-approve' },
      component: () => import('@/views/org_admin/member_approve.vue')
    },
    {
      path: 'roles',
      name: 'TeamRoleManagement',
      meta: { title: 'router.team-role-management' },
      component: () => import('@/views/org_admin/role_management.vue')
    },
    {
      path: 'limits',
      name: 'TeamLimitManagement',
      meta: { title: 'router.team-limit-management' },
      component: () => import('@/views/org_admin/limit_management.vue')
    },
    {
      path: 'consumption-records',
      name: 'TeamConsumptionRecords',
      meta: { title: 'router.team-consumption-records' },
      component: () => import('@/views/org_admin/consumption_records.vue')
    }
  ]
}
export default orgAdminRouter
